import { Routes } from '@angular/router';
import { PartnersSearchComponent } from './partners-search/partners-search.component';
import { PartnersEditComponent } from './partners-edit/partners-edit.component';
import { partnersResolver } from './partners.resolver';

export const contentsRoutes: Routes = [
  {
    path: 'search',
    component: PartnersSearchComponent,
  },
  {
    path: 'edit/:partnerFid',
    component: PartnersEditComponent,
    resolve: {
      partner: partnersResolver,
    },
  },
];
